var _g;
import * as React from "react";
function SvgIconUserFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1360.000000, -279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/User-friend/Multicolour/Colourful",
    transform: "translate(240.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4999992,7.50000045 L16.499999,7.50000045 C18.3225374,7.50000045 19.799999,6.06091403 19.799999,4.28571427 C19.799999,2.5105145 18.3225374,1.07142857 16.499999,1.07142857 C14.6774607,1.07142857 13.1999991,2.5105145 13.1999991,4.28571427 L13.1999991,4.28571475 C13.1999991,6.06091452 14.6774607,7.50000045 16.499999,7.50000045 L16.4999992,7.50000045 Z M18.1499991,8.5714161 L18.0193741,8.5714161 C17.5415617,8.73214282 17.0362492,8.83928567 16.4999992,8.83928567 C15.9637492,8.83928567 15.4584367,8.73214282 14.9806242,8.5714161 L14.8499992,8.5714161 C14.1487492,8.5714161 13.5024993,8.76897317 12.9353118,9.08705353 C13.7740618,9.96763388 14.2999992,11.1361607 14.2999992,12.4285714 L14.2999992,13.7142857 C14.2999992,13.7879464 14.2828117,13.8582589 14.2793742,13.9285714 L20.3499991,13.9285714 L20.349999,13.9285714 C21.2612699,13.9285714 21.9999995,13.2090301 21.9999995,12.3214285 L21.9999995,12.3212491 C22.0010367,10.2512927 20.2790972,8.5724545 18.1539523,8.5714161 C18.1525769,8.5714161 18.1512015,8.5714161 18.1498262,8.5714161 L18.1499991,8.5714161 Z",
    id: "path_secondary",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59999944,7.50001272 L6.59999928,7.50001272 C8.72629578,7.50001272 10.4499992,5.82106805 10.4499992,3.74999998 C10.4499992,1.67893191 8.72629578,0 6.59999928,0 C4.47370277,0 2.74999881,1.67893191 2.74999881,3.74999998 L2.74999881,3.7501797 C2.74896179,5.82013617 4.47090111,7.49897433 6.59604606,7.50001272 C6.59742142,7.50001272 6.59879679,7.50001272 6.60017216,7.50001272 L6.59999944,7.50001272 Z M9.23999937,8.57142836 L8.95468688,8.57142836 L8.95468725,8.57142836 C8.22128289,8.92059019 7.4163201,9.10372746 6.59999981,9.10714264 C5.75437483,9.10714264 4.96374985,8.90624979 4.24531237,8.57142836 L3.95999988,8.57142836 L3.9599999,8.57142836 C1.7731862,8.57198224 0.000584374985,10.2985578 4.08562073e-14,12.4285712 L4.08562073e-14,13.3928569 L4.08562073e-14,13.3928572 C4.08562073e-14,14.2804587 0.738729043,15 1.64999996,15 L11.5499997,15 L11.5499996,15 C12.4612705,15 13.1999997,14.2804587 13.1999997,13.3928572 L13.1999997,12.4285714 L13.1999997,12.4295757 C13.1999997,10.2995657 11.4278413,8.57253331 9.24103107,8.57142836 L9.23999937,8.57142836 Z",
    id: "path_primary",
    fill: "#4C69BA"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFriend);
export default __webpack_public_path__ + "static/media/icon-user-friend.5e39d9e1.svg";
export { ForwardRef as ReactComponent };